import { GetValidAMLExistsApiCallResponse } from 'api/typegen/client/questionnaire/valid-aml-exists/get';
import getValidAMLExistsApiCall from 'api/calls/getValidAMLExistsApiCall';
import useAuth from './useAuth';
import useProtectedQuery from './useProtectedQuery';

const useValidAMLExistsQuery = (enabled = false) => {
  const { token } = useAuth();
  return useProtectedQuery<GetValidAMLExistsApiCallResponse>(
    ['getValidAMLExistsApiCall', token],
    getValidAMLExistsApiCall,
    { enabled },
  );
};

export default useValidAMLExistsQuery;
